import { Component, OnInit, Input } from '@angular/core';
import { LayerSelectionDialogService } from '../dialogs/layer-selection-dialog/layer-selection-dialog.service.';
import { ResultMoment, ResultsService } from 'src/app/services/results.service';
import { MapService } from 'src/app/services/map.service';
import { SLMap } from 'src/app/model/sl-map';
import { ResultHistory } from 'src/app/model/result-history';

@Component({
	selector: 'app-result-gallery-button',
	templateUrl: './result-gallery-button.component.html',
	styleUrls: ['./result-gallery-button.component.scss']
})
export class ResultGalleryButtonComponent implements OnInit {

	constructor(private layerSelector: LayerSelectionDialogService, private resultsSvc: ResultsService) { }
	history: ResultHistory = null;
	@Input() size = 'mid';

	get isHidden(): boolean {
		if (this.history === null) {
			return true;
		}
		return this.history.momentCount <= 0;

	}
	ngOnInit(): void {
		this.history = this.resultsSvc.history;
	}
	ShowGallery() {
		this.layerSelector.ShowGallery();


	}

}
